import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

type Props = {
  statsCount: number;
  withFooter?: boolean;
};

const InfoCardSkeleton = ({ statsCount, withFooter = false }: Props) => (
  <Card data-testid="info-card-skeleton" className="rounded-xl shadow-none">
    <CardHeader className="gap-3 space-y-0 p-4">
      <div className="flex items-center gap-2">
        <Skeleton className="size-4.5 shrink-0 rounded-full" />
        <Skeleton className="h-3.5 w-28" />
      </div>
      <Skeleton className="h-6 w-20" />
    </CardHeader>
    <CardContent className="space-y-3 p-4 pt-0">
      <div className="flex gap-6">
        {Array.from({ length: statsCount }, (_, index) => (
          <div key={index} className="space-y-1">
            <Skeleton className="h-3 w-16" />
            <Skeleton className="h-4 w-6" />
          </div>
        ))}
      </div>
      {withFooter && <Skeleton className="h-3.5 w-44" />}
    </CardContent>
  </Card>
);

export default InfoCardSkeleton;
